/**
 * EventService
 * Service for managing events with views support
 */
import { CrudService } from '../base/CrudService';
/**
 * Service for event CRUD operations with view support
 */
export class EventService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? EventService.DEFAULT_SERVICE_PATH,
            basePath: EventService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    /**
     * Get paginated list of event views with optional filtering
     * @param filter - Optional filter criteria
     * @returns Paginated event list view response
     */
    async getViews(filter) {
        const response = await this.getViewsRaw(filter);
        // API returns array directly, wrap it in EventListViewResponse format
        const events = response.data ?? [];
        return {
            events: events,
            totalCount: events.length,
            page: 1,
            pageSize: events.length,
            totalPages: 1,
            hasNextPage: false,
            hasPreviousPage: false,
            upcomingCount: 0,
            ongoingCount: 0,
            pastCount: 0,
        };
    }
    /**
     * Get paginated list of event views (raw response)
     * @param filter - Optional filter criteria
     * @returns Raw response with event list
     */
    getViewsRaw(filter) {
        const url = this.buildUrl('views');
        return this.http.get(url);
    }
    /**
     * Get enriched event view by ID
     * @param id - Event ID
     * @returns Event model view with enriched data
     */
    async getView(id) {
        const response = await this.getViewRaw(id);
        if (!response.data) {
            throw new Error(`Event view not found: ${id}`);
        }
        return response.data;
    }
    /**
     * Get enriched event view by ID (raw response)
     * @param id - Event ID
     * @returns Raw response with event model view
     */
    getViewRaw(id) {
        const url = this.buildUrl(`${id}/view`);
        return this.http.get(url);
    }
    /**
     * Get events as list view (convenience method)
     * @param filter - Optional filter criteria
     * @returns Array of event model views
     */
    async listView(filter) {
        const response = await this.getViewsRaw(filter);
        return response.data ?? [];
    }
}
EventService.DEFAULT_SERVICE_PATH = 'events';
EventService.BASE_PATH = 'api/events';
//# sourceMappingURL=EventService.js.map